import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const GlobalSearchContext = createContext({
  query: '',
  setQuery: () => { },
  onSubmit: () => { },
  setSubmitHandler: () => { },
  setGlobalSearchHandler: () => { },
  setResultHandler: () => { },
  onResultSelect: () => { },
});

export const GlobalSearchProvider = ({ children }) => {
  const [query, setQuery] = useState('');
  const [submitHandler, _setSubmitHandler] = useState(null);
  const [globalSearchHandler, _setGlobalSearchHandler] = useState(null);
  const [resultHandler, _setResultHandler] = useState(null);

  // Wrap setters so that function values are stored correctly.
  // React's useState interprets a function argument as a state updater,
  // so we wrap with `() => fn` to store the function itself.
  const setSubmitHandler = useCallback((fn) => _setSubmitHandler(() => fn), []);
  const setGlobalSearchHandler = useCallback((fn) => _setGlobalSearchHandler(() => fn), []);
  const setResultHandler = useCallback((fn) => _setResultHandler(() => fn), []);

  const onSubmit = useCallback(() => {
    if (typeof submitHandler === 'function') {
      submitHandler(query);
    }
    if (typeof globalSearchHandler === 'function') {
      globalSearchHandler(query);
    }
  }, [submitHandler, globalSearchHandler, query]);

  const onResultSelect = useCallback((selection) => {
    if (typeof resultHandler === 'function') {
      resultHandler(selection);
    }
  }, [resultHandler]);

  const value = useMemo(() => ({
    query,
    setQuery,
    onSubmit,
    setSubmitHandler,
    setGlobalSearchHandler,
    setResultHandler,
    onResultSelect,
  }), [query, onSubmit, setGlobalSearchHandler, setResultHandler, onResultSelect]);

  return (
    <GlobalSearchContext.Provider value={value}>
      {children}
    </GlobalSearchContext.Provider>
  );
};

export const useGlobalSearch = () => useContext(GlobalSearchContext);

export default GlobalSearchContext;



